<template>
  <div id="editNewSurvey">
    <topBar :title="$t('newSurvey.title')" />
    <div class="commonContainer">
      <div class="editContainer">
        <el-card class="box-card">
          <div class="editBox">
            <div class="orangeIcon">
              <i class="el-icon-edit"></i>
            </div>
            <div class="editContent">

              <el-tabs v-model="activeName" align-center style="margin: 40px 0 30px 0" type="card">
                <el-tab-pane label="基本信息" name="first">
                </el-tab-pane>
                <el-tab-pane label="适用范围" name="second">
                </el-tab-pane>
                <el-tab-pane label="设置题目" name="third">
                </el-tab-pane>
                <el-tab-pane label="标签管理" name="four">
                </el-tab-pane>
              </el-tabs>

              <template v-if="activeName === 'first'">
                <el-form ref="form" :model="form" label-width="200px" :disabled="!canEdit" :rules="rule">
                  <el-form-item :label="$t('newSurvey.surveyName')" prop="name">
                    <el-input v-model="form.name" maxlength="250" :disabled="!canEdit"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('newSurvey.description')">
                    <el-input v-model="form.content" type="textarea" maxlength="250" :disabled="!canEdit"></el-input>
                  </el-form-item>
                  <!-- <el-form-item :label="$t('newSurvey.surveyType')" >
                    <el-radio-group v-model="form.type" :disabled="!!id">
                      <el-radio :label="1">开放问卷</el-radio>
                      <el-radio :label="2">巡店问卷</el-radio>
                    </el-radio-group>
                  </el-form-item> -->
                  <el-form-item label="显示序号">
                    <el-switch v-model="form.showSerialNum" :disabled="!canEdit"></el-switch>
                  </el-form-item>
                  <el-form-item :label="$t('newSurvey.autoPublishTime') + ':'">
                    <el-date-picker :disabled="!canEdit" v-model="form.publishStartTime" type="date" align="left"
                      unlink-panels :placeholder="$t('newSurvey.autoPublishTime')" value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('newSurvey.autoStopTime') + ':'">
                    <el-date-picker :disabled="!canEdit" v-model="form.publishEndTime" type="date" align="left"
                      unlink-panels :placeholder="$t('newSurvey.autoStopTime')" value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="'封面设置:'" prop="startImage">
                    <anyImageUpload v-model="form.startImage" labelWidth="0" :type="0" text="建议尺寸9:16"
                      :disabled="!canEdit" />
                  </el-form-item>
                  <el-form-item :label="'封底设置:'" prop="endImage">
                    <anyImageUpload v-model="form.endImage" labelWidth="0" :type="0" text="建议尺寸9:16"
                      :disabled="!canEdit" />
                  </el-form-item>
                  <el-form-item :label="'背景设置:'" prop="coverImage">
                    <anyImageUpload v-model="form.coverImage" labelWidth="0" :type="0" text="建议尺寸9:16"
                      :disabled="!canEdit" />
                  </el-form-item>
                  <el-form-item :label="'二维码海报:'" prop="qrcodeBgImage">
                    <anyImageUpload v-model="form.qrcodeBgImage" labelWidth="0" :type="0" :disabled="!canEdit"
                      text="建议尺寸1780 x 2480像素" />
                  </el-form-item>
                  <el-form-item :label="'二维码Logo:'">
                    <anyImageUpload v-model="form.qrcodeCenterImage" labelWidth="0" :type="0" :disabled="!canEdit"
                      text="建议尺寸1 : 1" />
                  </el-form-item>
                </el-form>
              </template>

              <template v-if="activeName === 'second'">
                <div class="card-box">
                  <span style="font-weight: 600;">可查看报表及问卷角色设置</span>
                  <multiPicker :label="$t('newSurvey.accessRole')" v-model="accessRoles" :options="tagOptions"
                    :ref="'access'" labelWidth="100" />
                  <el-form style="display: inline-flex;">
                    <matchUser2 label="可访问报表白名单：" v-model="form.whiteList" text="" :defaultFileName="form.whiteFile"
                      @change="updateAccounts(form.whiteList, 'whiteNos')" @fileChange="fileChange2" />
                  </el-form>
                  <ul>
                    <li style="font-size: 14px; color: red">* 角色设置为空时，默认仅对系统管理员角色开放问卷管理及报告查看</li>
                    <li style="font-size: 14px; color: red">* 报告查看权限，暂时不对门店内角色开放，仅支持与门店关联的角色，如市场管理等</li>
                  </ul>
                </div>
                <div style="margin-top: 20px;" class="card-box">
                  <span style="font-weight: 600;">可创建任务角色题设置</span>
                  <multiPicker2 :label="$t('newSurvey.accessRole')" v-model="taskRoles" :options="tagOptions"
                    :ref="'task'" labelWidth="100" />
                </div>
                <div style="margin-top: 20px;" class="card-box">
                  <span style="font-weight: 600;">问卷适用范围设置</span>
                  <el-form style="margin-top: 10px;" label-width="100px" size="mini" ref="ruleForm">
                    <scope-selector v-model="form.filter">
                    </scope-selector>
                    <!-- <el-form-item :label="$t('survey.range') + ':'">
                        <el-radio-group v-model="form.referenceType" style="width: 100%" ref="referenceType">
                          <el-radio v-for="item in referenceOptions" :key="item.itemValue" :label="item.itemValue">
                            {{ item.itemLabel }}
                          </el-radio>
                        </el-radio-group>
                      </el-form-item> -->

                    <!-- <div v-if="form.referenceType === 1">
                        <el-form-item :label="$t('filters.region')">
                          <el-select v-model="form.filter.regionNos" multiple :placeholder="$t('filters.chooseRegion')"
                            @visible-change="resetFilters()" class="filterSelect">
                            <el-option v-for="item in options.regions" :key="item.itemValue" :label="item.itemLabel"
                              :value="item.itemValue">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('filters.province')">
                          <el-select v-model="form.filter.provinceNos" multiple :placeholder="$t('filters.chooseProvince')"
                            @visible-change="resetFilters()" class="filterSelect">
                            <el-option v-for="item in options.provinces" :key="item.itemValue" :label="item.itemLabel"
                              :value="item.itemValue">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('filters.city')">
                          <el-select v-model="form.filter.cityNos" multiple :placeholder="$t('filters.chooseCity')"
                            @visible-change="resetFilters()" class="filterSelect">
                            <el-option v-for="item in options.cities" :key="item.itemValue" :label="item.itemLabel"
                              :value="item.itemValue">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('filters.reseller')">
                          <el-select v-model="form.filter.resellerNos" multiple :placeholder="$t('filters.chooseReseller')"
                            @visible-change="resetFilters()" class="filterSelect">
                            <el-option v-for="item in options.resellers" :key="item.itemValue" :label="item.itemLabel"
                              :value="item.itemValue">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('filters.subReseller')">
                          <el-select v-model="form.filter.subResellers" multiple
                            :placeholder="$t('filters.chooseSubReseller')" @visible-change="resetFilters()"
                            class="filterSelect">
                            <el-option v-for="item in options.subResellers" :key="item.itemValue"
                              :label="item.itemLabel" :value="item.itemValue">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="Cluster Name">
                          <el-select v-model="form.filter.clusterNames" multiple :placeholder="$t('choose')"
                            @visible-change="resetFilters()" class="filterSelect">
                            <el-option v-for="item in options.clusterNames" :key="item.itemValue"
                              :label="item.itemLabel" :value="item.itemValue">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="Concept">
                          <el-select v-model="form.filter.concepts" multiple :placeholder="$t('choose')"
                            @visible-change="resetFilters()" class="filterSelect">
                            <el-option v-for="item in options.concepts" :key="item.itemValue" :label="item.itemLabel"
                              :value="item.itemValue">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="City Tier">
                          <el-select v-model="form.filter.cityTiers" multiple :placeholder="$t('choose')"
                            @visible-change="resetFilters()" class="filterSelect">
                            <el-option v-for="item in options.cityTiers" :key="item.itemValue" :label="item.itemLabel"
                              :value="item.itemValue">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="Tz Group">
                          <el-select v-model="form.filter.tzGroups" multiple :placeholder="$t('choose')"
                            @visible-change="resetFilters()" class="filterSelect">
                            <el-option v-for="item in options.tzGroups" :key="item.itemValue" :label="item.itemLabel"
                              :value="item.itemValue">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="Format">
                          <el-select v-model="filter.formats" multiple :placeholder="$t('choose')"
                            @visible-change="resetFilters()" class="filterSelect">
                            <el-option v-for="item in options.formats" :key="item.itemValue" :label="item.itemLabel"
                              :value="item.itemValue">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="HubDoor">
                          <el-select v-model="form.filter.hubDoors" clearable :placeholder="$t('choose')" multiple
                            @visible-change="resetFilters()" class="filterSelect">
                            <el-option v-for="item in options.hubDoors" :key="item.itemValue" :label="item.itemLabel"
                              :value="item.itemValue">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <div style="text-align: center; margin-top: 10px;" v-if="!readOnly">
                          <el-button type="success" size="small" @click="addDoorFilter">添加</el-button>
                          <el-button type="info" size="small" @click="resetDoorFilter">重置</el-button>
                        </div> -->
                    <!-- </div> -->

                    <!-- <div v-if="form.referenceType === 2">
                        <el-form-item :label="$t('filters.doorName')">
                          <span @click="onChooseDoor" style="width: 45%;display: inline-flex;">
                            <el-input v-model="doorName" :placeholder="$t('filters.chooseDoorName')"
                              class="filterSelect">
                            </el-input>
                          </span>
                        </el-form-item>
                        <el-form-item label="POSID">
                          <el-input v-model="form.posIdStr" :placeholder="$t('filters.choosePOSID')"
                            class="filterSelect" style="width: 45%;display: inline-flex;">
                          </el-input>
                          <el-upload v-show="false" :action="'#'" :on-success="() => { }" :before-upload="beforeUpload">
                            <el-button ref="uploadBtn" v-show="false">点击上传</el-button>
                          </el-upload>
                          <div style="display: inline-flex;margin-left: 20px;" @click="upload">
                            <el-button type="primary">导入</el-button>
                          </div>
                          <el-button type="text" style="margin-left: 20px" @click="downloadTemplate"><i
                              class="el-icon-info"></i>模板下载</el-button>
                        </el-form-item>
                      </div> -->
                  </el-form>
                </div>
              </template>

              <template v-if="activeName === 'third'">
                <div class="customFormItem">
                  <span class="label">问卷题目</span>
                  <div class="formItemContent">
                    <el-card class="box-card questionsContainer" v-if="questions.length">
                      <ul class="questionBox">
                        <li v-for="(question, i) in questions" :key="i">
                          <el-row type="flex" :gutter="20">
                            <el-col :span="2">
                              <el-input v-model="question.sort" :placeholder="i + 1"
                                @change="changeSort(question.sort, i)" :disabled="!canEdit"></el-input>
                            </el-col>
                            <el-col :span="19">
                              <span v-if="question.necessary" style="color: red">*</span>
                              <span class="name">{{ question.name }} ({{ computeType(question.type) }})</span>
                              <el-tag type="warning" size="mini" style="margin-left: 5px;" v-show="question.tagId">{{tagExpand[question.tagId]}}</el-tag>
                              <br />
                              <div v-html="question.detail"></div>
                            </el-col>
                            <el-col :span="3" v-if="canEdit">
                              <i class="el-icon-edit" @click="onEditQuestion(i)" style="margin-right: 10px"></i>
                              <i class="el-icon-setting" v-if="question.type != 5" @click="onSetQuestion(i)"
                                style="margin-right: 10px"></i>
                              <i class="el-icon-delete" @click="onDeleteQuestion(i)"></i>
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="20" :offset="3">
                              <div class="options">
                                <div class="option" :key="j" v-for="(item, j) in question.items.filter(i => !!i.inUse)">
                                  ({{ j + 1 }}) {{
                                    item.content }}

                                  <span style="display: inline-flex; margin-left: 20px;">{{ computeScore(question.type,
                                    item.score) }}</span>
                                </div>
                              </div>
                            </el-col>
                          </el-row>
                        </li>
                      </ul>
                    </el-card>
                    <div class="input-box" v-if="canEdit">
                      <el-button type="text" icon="el-icon-circle-plus-outline" size="medium"
                        @click="addQuestion">添加题目</el-button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="activeName === 'four'">
                <div style="margin-top: 20px">
                  <el-button type="primary" @click="onAddTag(false, null)">{{ $t('add')
                  }}</el-button>
                  <el-table :data="tags" :key="2" style="width: 100%" v-loading="tableLoading" center>
                    <el-table-column prop="id" label="ID" width="100">
                    </el-table-column>
                    <el-table-column prop="tagName" label="标签名" align="center">
                    </el-table-column>
                    <el-table-column :label="$t('operation')" fixed="right" width="200" align="center">
                      <template slot-scope="scope">
                        <el-button type="text" @click="onAddTag(true, scope.row)" size="small">编辑</el-button>
                        <el-button type="text" @click="onDelTag(scope.row)" size="small">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="pagingBox">
                    <el-pagination background @current-change="currentChange" :current-page="current" :page-size="10"
                      layout="total, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                  </div>
                </div>
              </template>
            </div>

            <footer v-if="!this.id && this.activeName === 'first'">
              <el-button type="success" @click="next('second')">下一步, 设置范围</el-button>
              <el-button type="primary" @click="onClose">{{ $t('close') }}</el-button>
            </footer>

            <footer v-if="!this.id && this.activeName === 'second'">
              <el-button type="success" @click="next('first')">上一步, 设置信息</el-button>
              <el-button type="primary" @click="onClose">{{ $t('close') }}</el-button>
              <el-button type="success" @click="next('third')">下一步, 设置问卷</el-button>
            </footer>

            <footer v-if="!this.id && this.activeName === 'third'">
              <el-button type="success" @click="next('second')">上一步, 设置问卷</el-button>
              <el-button type="primary" @click="onSave">{{ $t('save') }}</el-button>
              <el-button type="primary" @click="onClose">{{ $t('close') }}</el-button>
            </footer>


            <footer v-if="this.id">
              <el-button type="primary" @click="onSave" v-if="canEdit">{{ $t('save') }}</el-button>
              <el-button type="primary" @click="onClose" v-if="canEdit">{{ $t('close') }}</el-button>
            </footer>

          </div>
        </el-card>
      </div>
    </div>
    <el-dialog :title="operation + $t('newSurvey.question')" :visible.sync="questionsDialog" width="70%" center :close-on-click-modal="false">
      <div style="margin: 10px 0 20px">
        <el-form :model="editQuestion" ref="editQuestion" label-width="100px">

          <el-form-item label="题目名称" required>
            <el-input v-model="editQuestion.name" maxlength="250" :required="true"></el-input>
          </el-form-item>

          <el-form-item label="题干:" prop="detail">
            <div ref="editor" id="editorDiv"></div>
          </el-form-item>

          <el-form-item label="题目标签">
            <el-select v-model="editQuestion.tagId" placeholder="请选择">
              <el-option v-for="item in [{ id: 0, tagName: '无' }].concat(questionTagOptions)" :key="item.id" :label="item.tagName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!--<multiLangInput
            label="题干"
            labelWidth="100"
            v-model="editQuestion.detail"
          />-->
          <el-form-item label="是否上传图片">
            <el-switch v-model="editQuestion.needUpload"></el-switch>
            <div style="margin-left: 20px; display: inline-block;" v-if="editQuestion.needUpload">
              至少上传一张图片
              <el-switch style="margin-left: 8px;" v-model="editQuestion.mustUpload"></el-switch>
            </div>

          </el-form-item>
          <el-form-item label="是否必答">
            <el-switch v-model="editQuestion.necessary"></el-switch>
          </el-form-item>

          <el-form-item label="至少选择几项" v-show="editQuestion.type == 2">
            <el-input-number v-model="editQuestion.optionMin"></el-input-number>
          </el-form-item>

          <el-form-item label="最多选择几项" v-show="editQuestion.type == 2">
            <el-input-number v-model="editQuestion.optionMax"></el-input-number>
          </el-form-item>

          <div v-on:mouseup="changeType($event, editQuestion.type)">
            <el-form-item label="题目类型">
              <el-radio-group v-model="editQuestion.type">
                <el-radio :label="1" border>单选题</el-radio>
                <el-radio :label="2" border>多选题</el-radio>
                <el-radio :label="3" border>NPS量表题</el-radio>
                <el-radio :label="4" border>填空题</el-radio>
                <el-radio :label="5" border>门店信息题</el-radio>
                <!--<el-radio label="5" border>图片/视频</el-radio>-->
              </el-radio-group>
            </el-form-item>
          </div>

          <div class="customFormItem customFormItemInner" v-show="editQuestion.type == 1 || editQuestion.type == 2">
            <span class="label">题目选项</span>
            <div class="formItemContent">
              <el-card class="box-card questionOptionsContainer" v-if="editQuestion.items && editQuestion.items.length">
                <ul class="optionsBox">
                  <li v-for="(opt, i) in editQuestion.items" :key="i">
                    <el-row type="flex" :gutter="20">
                      <el-col :span="1">
                        <span>{{ i + 1 }}. </span>
                      </el-col>
                      <el-col :span="22">
                        <el-input v-model="editQuestion.items[i].content" maxlength="250" required></el-input>
                        <el-form :inline="true">
                          <el-form-item label="是否输入项" style="margin-bottom: 0">
                            <el-switch v-model="opt.isInput"></el-switch>
                          </el-form-item>
                          <el-form-item label="是否必填" style="margin-bottom: 0">
                            <el-switch v-model="opt.necessary"></el-switch>
                          </el-form-item>
                          <el-form-item style="margin-bottom: 0;float: right;">
                            <el-radio v-model="opt.score" :label="1">1分项</el-radio>
                            <el-radio v-model="opt.score" :label="0">0分项</el-radio>
                            <el-radio v-model="opt.score" :label="-1">不计分项</el-radio>
                          </el-form-item>
                        </el-form>

                        <!--                        <el-row type="flex">
                          <el-form :inline="true">
                            <el-form-item label="是否输入项">
                              <el-switch v-model="opt.isInput"></el-switch>
                            </el-form-item>
                            <el-form-item label="是否必填" style="margin-left: 40px">
                              <el-switch v-model="opt.necessary"></el-switch>
                            </el-form-item>
                          </el-form>
                        </el-row>-->
                      </el-col>
                      <el-col :span="1">
                        <i class="el-icon-delete" @click="onDeleteItem(i)"></i>
                      </el-col>
                    </el-row>
                  </li>
                </ul>
              </el-card>
              <div class="input-box">
                <el-button type="text" icon="el-icon-circle-plus-outline" size="medium"
                  @click="addOption">添加选择项</el-button>
                <!-- <el-button type="text" icon="el-icon-circle-plus-outline" size="medium"
                  @click="addOtherOption">添加其他项</el-button> -->
              </div>
            </div>
          </div>

          <el-form-item label="量表维度" v-show="editQuestion.type == 3">
            <el-input-number v-model="editQuestion.maxScore" :min="1" :max="10"></el-input-number>
          </el-form-item>

          <div class="scoreText" v-show="editQuestion.type == 3">
            <ul>
              <li v-for="count in editQuestion.maxScore" :key="count"></li>
            </ul>
            <div class="scoreTextInput">
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="6"><el-input v-model="editQuestion.leftLabel" placeholder="最低分文案(/换行)"
                    class="textInput"></el-input></el-col>
                <el-col :span="6"><el-input v-model="editQuestion.rightLabel" placeholder="最高分文案(/换行)"
                    class="textInput"></el-input></el-col>
              </el-row>
            </div>

          </div>
          <div class="customFormItem customFormItemInner" v-show="editQuestion.type == 5">
            <span class="label">附加题目</span>
            <div class="formItemContent">
              <el-card class="box-card questionOptionsContainer">
                <ul class="optionsBox">
                  <li v-for="i in 4" :key="i">
                    <el-row type="flex" :gutter="20" v-if="editQuestion.items && editQuestion.items[i - 1]">
                      <el-col :span="1">
                        <span>{{ i }}. </span>
                      </el-col>
                      <el-col :span="22">
                        <el-row type="flex">
                          <el-input v-model="editQuestion.items[i - 1].content" :disabled="true"></el-input>
                        </el-row>
                        <el-row type="flex">
                          <el-form :inline="true">
                            <el-form-item label="是否启用">
                              <el-switch v-model="editQuestion.items[i - 1].inUse"></el-switch>
                            </el-form-item>
                            <el-form-item label="是否必填" style="margin-left: 40px">
                              <el-switch v-model="editQuestion.items[i - 1].necessary"
                                @change="changeItem(editQuestion.items[i - 1])"></el-switch>
                            </el-form-item>
                          </el-form>
                        </el-row>
                      </el-col>
                    </el-row>
                  </li>
                </ul>
              </el-card>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="questionsDialog = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="confirmQuestion">{{ $t('confirm') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="operation + $t('newSurvey.question')" :visible.sync="questionSetDialog" width="70%" center :close-on-click-modal="false">
      <div style="margin: 10px 0 20px">
        <el-form :model="editQuestion" ref="editQuestion2" label-width="100px">

          <el-form-item label="题目名称" required>
            <el-input v-model="editQuestion.name" maxlength="250" :required="true"></el-input>
          </el-form-item>

          <el-form-item label="题干:" prop="detail">
            <div ref="editor" id="editorDiv"></div>
          </el-form-item>

          <el-form-item label="题目标签">
            <el-select v-model="editQuestion.tagId" placeholder="请选择">
              <el-option v-for="item in [{ id: 0, tagName: '无' }].concat(questionTagOptions)" :key="item.id" :label="item.tagName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!--<multiLangInput
            label="题干"
            labelWidth="100"
            v-model="editQuestion.detail"
          />-->
          <el-form-item label="是否上传图片">
            <el-switch v-model="editQuestion.needUpload"></el-switch>
          </el-form-item>

          <el-form-item label="是否必答">
            <el-switch v-model="editQuestion.necessary"></el-switch>
          </el-form-item>

          <el-form-item label="至少选择几项" v-show="editQuestion.type == 2">
            <el-input-number v-model="editQuestion.optionMin"></el-input-number>
          </el-form-item>

          <el-form-item label="最多选择几项" v-show="editQuestion.type == 2">
            <el-input-number v-model="editQuestion.optionMax"></el-input-number>
          </el-form-item>

          <div v-on:mouseup="changeType($event, editQuestion.type)">
            <el-form-item label="题目类型">
              <el-radio-group v-model="editQuestion.type">
                <el-radio :label="1" border>单选题</el-radio>
                <el-radio :label="2" border>多选题</el-radio>
                <el-radio :label="3" border>NPS量表题</el-radio>
                <el-radio :label="4" border>填空题</el-radio>
                <el-radio :label="5" border>门店信息题</el-radio>
                <!--<el-radio label="5" border>图片/视频</el-radio>-->
              </el-radio-group>
            </el-form-item>
          </div>

          <div class="customFormItem customFormItemInner" v-show="editQuestion.type == 1 || editQuestion.type == 2">
            <span class="label">题目选项</span>
            <div class="formItemContent">
              <el-card class="box-card questionOptionsContainer" v-if="editQuestion.items && editQuestion.items.length">
                <ul class="optionsBox">
                  <li v-for="(opt, i) in editQuestion.items" :key="i">
                    <el-row type="flex" :gutter="20">
                      <el-col :span="1">
                        <span>{{ i + 1 }}. </span>
                      </el-col>
                      <el-col :span="22">
                        <el-input v-model="editQuestion.items[i].content" maxlength="250" required></el-input>
                        <el-form :inline="true">
                          <el-form-item label="是否输入项" style="margin-bottom: 0">
                            <el-switch v-model="opt.isInput"></el-switch>
                          </el-form-item>
                          <el-form-item label="是否必填" style="margin-bottom: 0">
                            <el-switch v-model="opt.necessary"></el-switch>
                          </el-form-item>
                        </el-form>
                        <!--                        <el-row type="flex">
                          <el-form :inline="true">
                            <el-form-item label="是否输入项">
                              <el-switch v-model="opt.isInput"></el-switch>
                            </el-form-item>
                            <el-form-item label="是否必填" style="margin-left: 40px">
                              <el-switch v-model="opt.necessary"></el-switch>
                            </el-form-item>
                          </el-form>
                        </el-row>-->
                      </el-col>
                      <el-col :span="1">
                        <i class="el-icon-delete" @click="onDeleteItem(i)"></i>
                      </el-col>
                    </el-row>
                  </li>
                </ul>
              </el-card>
              <div class="input-box">
                <el-button type="text" icon="el-icon-circle-plus-outline" size="medium"
                  @click="addOption">添加选择项</el-button>
                <!-- <el-button type="text" icon="el-icon-circle-plus-outline" size="medium"
                  @click="addOtherOption">添加其他项</el-button> -->
              </div>
            </div>
          </div>

          <el-form-item label="量表维度" v-show="editQuestion.type == 3">
            <el-input-number v-model="editQuestion.maxScore" :min="1" :max="10"></el-input-number>
          </el-form-item>

          <div class="scoreText" v-show="editQuestion.type == 3">
            <ul>
              <li v-for="count in editQuestion.maxScore" :key="count"></li>
            </ul>
            <div class="scoreTextInput">
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="6"><el-input v-model="editQuestion.leftLabel" placeholder="最低分文案(/换行)"
                    class="textInput"></el-input></el-col>
                <el-col :span="6"><el-input v-model="editQuestion.rightLabel" placeholder="最高分文案(/换行)"
                    class="textInput"></el-input></el-col>
              </el-row>
            </div>

          </div>

          <div class="customFormItem customFormItemInner" v-show="editQuestion.type == 5">
            <span class="label">附加题目</span>
            <div class="formItemContent">
              <el-card class="box-card questionOptionsContainer">
                <ul class="optionsBox">
                  <li v-for="i in 4" :key="i">
                    <el-row type="flex" :gutter="20" v-if="editQuestion.items && editQuestion.items[i - 1]">
                      <el-col :span="1">
                        <span>{{ i }}. </span>
                      </el-col>
                      <el-col :span="22">
                        <el-row type="flex">
                          <el-input v-model="editQuestion.items[i - 1].content" :disabled="true"></el-input>
                        </el-row>
                        <el-row type="flex">
                          <el-form :inline="true">
                            <el-form-item label="是否启用">
                              <el-switch v-model="editQuestion.items[i - 1].inUse" :disabled="i <= 2"></el-switch>
                            </el-form-item>
                            <el-form-item label="是否必填" style="margin-left: 40px">
                              <el-switch v-model="editQuestion.items[i - 1].necessary" :disabled="i <= 2"></el-switch>
                            </el-form-item>
                          </el-form>
                        </el-row>
                      </el-col>
                    </el-row>
                  </li>
                </ul>
              </el-card>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="questionsDialog = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="confirmQuestion">{{ $t('confirm') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('survey.editLogic')" :visible.sync="logicDialog" width="70%" center :close-on-click-modal="false">
      <div style="margin: 10px 0 20px">
        <div>{{ editQuestion.sort }} &nbsp; {{ editQuestion.name }} ({{ computeType(editQuestion.type) }})</div>
        <ul style="margin-top: 20px" v-if="editQuestion.type === 1 || editQuestion.type === 2">
          <li v-for="(opt, i) in editQuestion.items" :key="i" style="margin-top: 10px">
            <el-row type="flex" justify="center" align="middle">
              <el-col :span="14">
                <div class="optionBox">{{ i + 1 }}. {{ opt.content }}</div>
              </el-col>
              <el-col :span="2">{{ $t('survey.skip') }}</el-col>
              <el-col :span="8">
                <div>
                  <el-select v-model="opt.skipTo" :placeholder="$t('survey.chooseSkip')" style="width: 100%">
                    <el-option v-for="item in skipOptions" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
          </li>
        </ul>
        <ul style="margin-top: 20px" v-if="editQuestion.type === 3">
          <li v-for="(scope, i) in editQuestion.scoreSkip" :key="i" style="margin-top: 10px">
            <el-row type="flex" justify="center" align="middle">
              <el-col :span="11">
                <div class="scopeBox">
                  {{ i === 0 ? 0 : '' }}
                  <el-input v-if="i !== 0" class="scopeInput" v-model="editQuestion.scoreSkip[i].start"></el-input>
                  &nbsp;&lt; {{ $t('survey.curScore') }} &le;&nbsp;
                  {{ i === editQuestion.scoreSkip.length - 1 ? editQuestion.maxScore : '' }}
                  <el-input v-if="i !== editQuestion.scoreSkip.length - 1" class="scopeInput"
                    v-model="editQuestion.scoreSkip[i].end"></el-input>
                </div>
              </el-col>
              <el-col :span="2">{{ $t('survey.skip') }}</el-col>
              <el-col :span="11">
                <div>
                  <el-select v-model="editQuestion.scoreSkip[i].skipTo" :placeholder="$t('survey.chooseSkip')"
                    style="width: 100%">
                    <el-option v-for="item in skipOptions" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
          </li>
        </ul>
        <div class="buttonContainer">
          <el-button type="text" v-if="editQuestion.type === 3" icon="el-icon-circle-plus-outline" size="medium"
            @click="addScoreSkip">
            {{ $t('survey.addScore') }}
          </el-button>
        </div>
        <div class="depContainer" v-if="editQuestion.sort !== 1">
          <el-row :gutter="20" type="flex" align="">
            <el-col :span="4">
              <div class="align-item">
                {{ $t('survey.questionDep') }}
              </div>
            </el-col>
            <el-col :span="19">
              <ul class="depList">
                <li v-for="(dependOn, i) in editQuestion.dependOn" :key="i">
                  <el-row :gutter="10" type="flex" align="baseline">
                    <el-col :span="23">
                      <div v-if="dependOn.type === 1 || dependOn.type === 2">
                        <div class="optionBox">
                          {{ dependOn.sort }}.{{ questions[dependOn.sort - 1].name }}
                        </div>
                        <div class="optContainer checkboxList">
                          <el-checkbox-group v-model="dependOn.itemSort">
                            <el-checkbox v-for="(item, j) in questions[dependOn.sort - 1].items" :key="j"
                              :label="item.sort">{{ item.sort }}. {{
                                item.content }}</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div>{{ $t('survey.appear') }}</div>
                      </div>
                      <div v-if="dependOn.type === 3">
                        <div class="optionBox">
                          {{ dependOn.sort }}.{{ questions[dependOn.sort - 1].name }}
                        </div>
                        <div class="optContainer checkboxList">
                          <div v-for="(scope, k) in dependOn.scoreRanges" :key="k">
                            <el-checkbox v-model="dependOn.scoreRanges[k].enable">
                              <em v-if="k === 0">0</em>
                              <el-input class="scopeInput" v-model="dependOn.scoreRanges[k].start"
                                v-if="k !== 0"></el-input>
                              &nbsp;&lt; {{ $t('survey.curScore') }} &le;&nbsp;
                              <em v-if="k === dependOn.scoreRanges.length - 1">{{ editQuestion.maxScore }}</em>
                              <el-input class="scopeInput" v-model="dependOn.scoreRanges[k].end"
                                v-if="k !== dependOn.scoreRanges.length - 1"></el-input>
                            </el-checkbox>
                          </div>
                          <el-button type="text" icon="el-icon-circle-plus-outline" size="medium"
                            @click="addDepScore(dependOn)">
                            {{ $t('survey.addScore') }}
                          </el-button>
                        </div>
                        <div>{{ $t('survey.appear') }}</div>
                      </div>
                    </el-col>
                    <el-col :span="1">
                      <div class="align-item">
                        <i class="el-icon-delete" @click="onDeleteDep(dependOn)"></i>
                      </div>
                    </el-col>
                  </el-row>
                </li>
              </ul>
              <el-button type="text" icon="el-icon-circle-plus-outline" size="medium" @click="addDepQuestion">
                {{ $t('survey.addQuestion') }}
              </el-button>
            </el-col>
          </el-row>
          <el-row :gutter="20" type="flex" align="middle"
            v-if="editQuestion.dependOn && editQuestion.dependOn.length >= 2">
            <el-col :span="4">
              <div class="align-item">
                {{ $t('survey.multiDep') }}:
              </div>
            </el-col>
            <el-col :span="19">
              <el-radio-group v-model="editQuestion.dependType">
                <el-radio :label="0">{{ $t('survey.depType1') }}</el-radio>
                <el-radio :label="1">{{ $t('survey.depType2') }}</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmSetting">{{ $t('submit') }}</el-button>
        <el-button @click="logicDialog = false">{{ $t('close') }}</el-button>
      </span>
      <el-dialog width="50%" :title="$t('survey.chooseDep')" center :visible.sync="innerQuestionDialog" append-to-body :close-on-click-modal="false">
        <div class="checkboxList questionList">
          <el-checkbox-group v-model="innerCheckList">
            <el-checkbox v-for="(question, i) in innerQuestionList" :key="i" :label="question.sort">{{ question.sort }}.
              {{ question.name }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="chooseDepQuestions">{{ $t('confirm') }}</el-button>
          <el-button @click="innerQuestionDialog = false">{{ $t('cancel') }}</el-button>
        </span>
      </el-dialog>
    </el-dialog>
    <el-dialog :title="tagTitle" :visible.sync="tagDialog" width="50%" center :close-on-click-modal="false">
      <el-form :ref="'tagForm'" :label-position="'left'" label-width="75px">
        <el-form-item label="标签名:">
          <el-input v-model="tagData.tagName"></el-input>
        </el-form-item>
        <div style="text-align: center;">
          <el-button @click="tagConfirm">{{ $t('confirm') }}</el-button>
        </div>
      </el-form>
    </el-dialog>
    <pickDoor v-model="form.posIdStr" ref='pickDoor' />
  </div>
</template>

<script>
import TopBar from "../components/TopBar.vue";
import _ from "lodash";
import scopeSelector from "../components/scopeSelector";
import anyImageUpload from "../components/anyImageUpload.vue";
import multiPicker from "../components/multiPicker.vue";
import multiPicker2 from "../components/multiPicker2.vue";
import matchUser from "../components/matchUser.vue";
import matchUser2 from "../components/matchUser2.vue";
import fileUpload from "../components/fileUpload";
import Editor from "wangeditor";
import pickDoor from "../components/pickDoor.vue";

export default {
  name: "EditNewSurvey",
  components: {
    topBar: TopBar,
    anyImageUpload,
    multiPicker,
    multiPicker2,
    fileUpload,
    matchUser,
    matchUser2,
    pickDoor,
    scopeSelector
  },
  data: function () {
    return {
      id: this.$route.query.id,
      isCopy: this.$route.query.isCopy === "1",
      activeName: "first",
      initForm: {
        name: "", // 问卷名称
        type: 1,
        content: "", // 问卷描述
        showSerialNum: true, // 显示序号
        startImage: "", // 封面图片地址
        endImage: "", // 封底图片地址
        coverImage: "", // 背景图片地址
        qrcodeBgImage: "", // 二维码背景图片地址
        qrcodeCenterImage: "", // 二维码logo
        referenceType: 0, // 关联类型 0 不限制 1 条件筛选 2 指定门店
        accountList: [],
        accountNos: [],
        whiteFile: "",
        whiteList: [],
        whiteNos: [],
        posIdStr: "",
        roles: [],
        taskRoles: [],
        accountFile: "",
        publishStartTime: "",
        publishEndTime: "",
        filter: {
          accountList: [],
          accountNos: [],
          scopes: [],
        }
        //   filter: {
        //   regionNos: [],
        //   provinceNos: [],
        //   cityNos: [],
        //   resellerNos: [],
        //   subResellers: [],
        //   clusterNames: [],
        //   concepts: [],
        //   cityTiers: [],
        //   tzGroups: [],
        //   formats: [],
        //   hubDoors: [],
        // },
      },
      // filter: {
      //   regionNos: [],
      //   provinceNos: [],
      //   cityNos: [],
      //   resellerNos: [],
      //   subResellers: [],
      //   clusterNames: [],
      //   concepts: [],
      //   cityTiers: [],
      //   tzGroups: [],
      //   formats: [],
      //   hubDoors: [],
      // },
      form: {},
      // scopeForm: {
      //   // accounts: [], // 指定用户
      //   domains:[],
      //   regions: [], // 区域
      //   provinces: [], // 省份
      //   citys: [], // 城市
      //   resellers: [], // 客户
      //   roles: [], // 角色
      // },
      accessRoles: [], // 可访问角色
      taskRoles: [],
      doorInfos: [],
      questionsDialog: false,
      questionSetDialog: false,
      logicDialog: false,
      innerQuestionDialog: false,
      tagOptions: [],
      tagOptionsAll: [],
      referenceOptions: [
        {
          itemValue: 0,
          itemLabel: "不限定门店"
        },
        {
          itemValue: 1,
          itemLabel: "按条件选择"
        },
        {
          itemValue: 2,
          itemLabel: "选择具体门店"
        }
      ],
      options: {
        regions: [],
        provinces: [],
        cities: [],
        resellers: [],
        subResellers: [],
        clusterNames: [],
        concepts: [],
        cityTiers: [],
        tzGroups: [],
        formats: [],
        hubDoors: []
      },
      skipOptions: [],
      innerCheckList: [],
      innerQuestionList: [],
      questions: [],
      initQuestions: [],
      editQuestion: {},
      initQuestion: {
        tagId: 0,
        type: 1,
        maxScore: 10,
        items: [],
        needUpload: false,
        necessary: true,
        optionMin: 1,
        optionMax: 10,
        name: "",
        detail: "",
        rightLabel: "",
        leftLabel: "",
        scoreSkip: [],
        dependType: 0,
        dependOn: []
      },
      operation: "",
      editIndex: "", // 当前编辑的题目的索引
      editor: null,
      currentContent: "",
      doorName: "",
      publishDate: [],
      rule: {
        name: [
          { required: true, message: "问卷名称不能为空", trigger: "blur" }
        ],
        startImage: [
          { required: true, message: "封面图不能为空", trigger: "blur" }
        ],
        endImage: [
          { required: true, message: "封底图不能为空", trigger: "blur" }
        ],
        coverImage: [
          { required: true, message: "背景图不能为空", trigger: "blur" }
        ],
        qrcodeBgImage: [
          { required: true, message: "二维码海报不能为空", trigger: "blur" }
        ]
      },
      roleOptions: [],
      getRoleflag: false,
      tagDialog: false,
      tags: [],
      questionTagOptions: [],
      tagData: {
        id: 0,
        tagName: ''
      },
      tagExpand:{},
      tagTitle: '',
      tagEdit: false,
      tableLoading: false,
      current: 1,
      total: 0
    };
  },
  watch: {
    activeName: function (val) {
      if (val == "third" && this.id && !this.isCopy) {
        this.$message.warning("修改题目将会使已有的提交记录作废，请谨慎操作！");
      }
    }
  },
  computed: {
    canEdit() {
      let copy = Number(this.$route.query.isCopy || 0) == 1;
      if (copy) {
        this.form.publishStartTime = "";
        this.form.publishEndTime = "";
      }
      return Number(this.$route.query.published || 0) != 2 || copy;
    },
    defaultSkip() {
      return [
        {
          name: this.$t("survey.skipType1"),
          id: 0 // 正常跳转
        },
        {
          name: this.$t("survey.skipType2"),
          id: -1 // 跳到结尾
        }
      ];
    }
  },
  async mounted() {
    await this.getDefaultImage();
    await this.getRoles();
    await this.getDoorAttribute()
    await this.getTagOptions()
    await this.getTags(true)
    if (this.id) {
      await this.initData();
    } else {
      this.onReset();
    }
  },
  methods: {
    changeItem(item) {
      if (item.necessary) {
        item.content += "（必填）";
      } else {
        item.content = item.content.replace("（必填）", "");
      }
    },
    onChooseDoor: function () {
      this.$refs.pickDoor.openDialog();
    },
    async getRoles() {
      if (this.getRoleflag || this.roleOptions.length > 0) return;
      this.getRoleflag = true;
      let res = await window.instance.post(
        window.pubServer + "/external/searchQuery",
        {}
      );
      res = res.data.data.searchQuery;
      this.roleOptions = res.roles;
      this.tagOptionsAll = res.roles;
      this.tagOptions = this.getPureOptionList(this.roleOptions, "roleName");
      this.getRoleflag = false;
    },
    async getDefaultImage() {
      let res = await window.instance.get(
        openSurveyReqUrl + "condition/defaultImage"
      );
      res = res.data;
      if (res.code === 200) {
        res = res.data;
        this.initForm.startImage = res.startImage;
        this.initForm.endImage = res.endImage;
        this.initForm.coverImage = res.coverImage;
        this.initForm.qrcodeBgImage = res.qrcodeBgImage;
        this.initForm.qrcodeCenterImage = res.qrcodeCenterImage;
      }
    },
    async getDoorAttribute() {
      let res = await window.instance.post(openSurveyReqUrl + 'condition/doorFilters', {})
      res = res.data
      if (res.code === 200) {
        this.options = res.data
      }
    },
    onAddTag(edit, row) {
      this.tagEdit = edit
      console.log(this.tagEdit)
      this.tagTitle = edit ? '编辑标签' : '新增标签'
      this.tagData = {
        id: 0,
        tagName: ''
      }
      if (edit) {
        this.tagData = _.cloneDeep(row)
      }
      this.tagDialog = true
    },
    async onDelTag(row) {
      let tagData = {
        id: row.id,
        tagName: row.tagName
      }

      let res = await window.instance.post(openSurveyReqUrl + "tags/del", tagData)
      res = res.data
      if (res.code === 200) {
        this.$message.success("操作成功！")
        await this.getTags()
        await this.getTagOptions()
      }
    },
    async tagConfirm() {
      if (!this.tagData.tagName) {
        this.$message.error("标签名不能为空！")
        return;
      }
      console.log(this.tagEdit)
      let operation = this.tagEdit ? 'tags/update' : 'tags/create'
      let res = await window.instance.post(openSurveyReqUrl + operation, this.tagData)
      res = res.data
      if (res.code === 200) {
        this.$message.success("操作成功！")
        await this.getTags()
        await this.getTagOptions()
        this.tagDialog = false
      }

    },
    async getTagOptions() {
      let res = await window.instance.post(openSurveyReqUrl + 'tags', { current: 1, size: 999 })
      res = res.data
      if (res.code === 200) {
        this.questionTagOptions = res.data.list
        this.tagExpand = {}
        this.questionTagOptions.forEach(t=>{
          this.tagExpand[t.id] = t.tagName
        })
      }
    },
    async getTags(reset) {
      if (reset) {
        this.current = 1
      }
      let res = await window.instance.post(openSurveyReqUrl + 'tags', { current: this.current, size: 10 })
      res = res.data
      if (res.code === 200) {
        this.tags = res.data.list
        this.total = res.data.total
      }
    },
    currentChange(index) {
      this.current = index
      this.getTags(false)
    },
    resetEditor(content) {
      this.editor.txt.html(content);
    },
    editorInit() {
      let that = this;
      this.editor = new Editor(this.$refs.editor);
      this.editor.config.pasteFilterStyle = false;
      this.editor.config.showLinkImg = false;
      this.editor.config.height = 580;
      this.editor.config.focus = false;
      this.editor.config.placeholder = "请输入题干";
      this.editor.config.onchange = html => {
        this.currentContent = html;
      };
      this.editor.config.excludeMenus = ["video"];
      this.editor.config.customUploadImg = function (files, insert) {
        if (files.length > 1) {
          that.$message.error("每次只能上传1张图片！");
          return;
        }
        const isIMAGE =
          files[0].type === "image/jpeg" ||
          "image/gif" ||
          "image/png" ||
          "image/jpg";
        const isLt800K = files[0].size / 1024 < 2048;
        if (!isIMAGE) {
          that.$message.error("上传图片只支持jpg/jpeg/gif/png格式!");
          return;
        }
        if (!isLt800K) {
          that.$message.error("上传图片大小不能超过 2M!");
          return;
        }
        let formdata = new FormData();
        formdata.append("file", files[0]);
        formdata.append("type", 6);
        window.instance
          .post(window.pubServer + "/upload/upload", formdata)
          .then(res => {
            insert(res.data.data.result.imageUrl);
          });
      };
      this.editor.create();
      console.log("this.editor", this.editor);
      this.editor.txt.html(this.currentContent);
    },
    onClose: function () {
      this.$router.push({
        path: "/openSurvey/newSurvey",
        query: { published: this.$route.query.published }
      });
    },
    updateAccounts: function (accounts, target) {
      this.form[target] = accounts
        .filter(ac => ac.account);
    },
    fileChange2: function (fileName) {
      this.form.whiteFile = fileName;
    },
    fileChange: function (fileName) {
      this.form.accountFile = fileName;
    },
    debugQuestions: function () {
      console.log("this.questions", this.questions);
    },
    onReset: function () {
      this.form = _.cloneDeep(this.initForm);
      this.questions = _.cloneDeep(this.initQuestions);
      console.log("this.questions", this.questions);
    },
    resetFilters: async function () {
      this.form.filter.hubDoors = this.form.filter.hubDoors ? this.form.filter.hubDoors : []
      let res = await window.instance.post(
        openSurveyReqUrl + "condition/doorFilters",
        this.form.filter
      );
      res = res.data;
      if (res.code === 200) {
        this.options = res.data;
      }
    },
    initData: async function () {
      let res = await window.instance.get(
        openSurveyReqUrl + "questionnaire/" + this.id
      );
      res = res.data;
      if (res.code === 200) {
        const result = res.data;
        this.initForm.name = result.name;
        this.initForm.type = result.type;
        this.initForm.content = result.content;
        this.initForm.showSerialNum = result.showSerialNum;
        this.initForm.startImage = result.startImage
          ? result.startImage
          : this.initForm.startImage;
        this.initForm.endImage = result.endImage
          ? result.endImage
          : this.initForm.endImage;
        this.initForm.coverImage = result.coverImage
          ? result.coverImage
          : this.initForm.coverImage;
        this.initForm.qrcodeBgImage = result.qrcodeBgImage
          ? result.qrcodeBgImage
          : this.initForm.qrcodeBgImage;
        this.initForm.qrcodeCenterImage = result.qrcodeCenterImage
          ? result.qrcodeCenterImage
          : this.initForm.qrcodeCenterImage;
        this.initForm.referenceType = result.referenceType;
        this.initForm.filter = result.filter;
        this.initForm.accountFile = result.accountFile;
        this.initForm.posIdStr = result.posIds.join(",");
        this.getSelectedLabels(result.roles);
        this.getSelectedLabels2(result.taskRoles);
        this.initForm.accountList = result.accountList;
        this.initForm.whiteList = result.whiteList;
        this.initForm.publishStartTime = result.publishStartTime;
        this.initForm.publishEndTime = result.publishEndTime;

        this.initQuestions = result.questions;
        this.onReset();
      } else {
        this.$message.warning(res.message);
      }
    },

    // 把问题转换成提交的时候需要的格式
    convertQuestionToSubmit: function (question, index) {
      let result = _.cloneDeep(question);
      result.sort = _.toNumber(index) + 1; // 序号
      return result;
    },

    // 保存
    onSave: async function () {
      if (this.activeName == "first") {
        let valid = await this.$refs["form"].validate();
        if (!valid) {
          return;
        }
      }

      // 提交的格式
      let submitResult = _.cloneDeep(this.form);
      submitResult.posIds = submitResult.posIdStr
        ? submitResult.posIdStr.split(",")
        : [];
      // submitResult.roles = this.accessRoles;
      const accessRoles2 = this.getIdsFromOptions(
        this.tagOptionsAll,
        this.accessRoles
      );
      const taskRoles2 = this.getIdsFromOptions(
        this.tagOptionsAll,
        this.taskRoles
      );
      submitResult.roles = accessRoles2 || [];
      submitResult.taskRoles = taskRoles2 || [];
      submitResult.type = 1;
      // submitResult.hubDoors = submitResult.hubDoors===""?[]:submitResult.hubDoors;
      // console.log('this.form.attachment', this.form.attachment)
      // submitResult.attachment = this.form.attachment[0] ? this.form.attachment[0].docUrl : ''
      let submitQuestions = [];
      _.each(this.questions, (question, i) => {
        if (question.type == 5) {
          submitResult.type = 2;
        }
        const convertedQuestion = this.convertQuestionToSubmit(question, i);
        submitQuestions.push(convertedQuestion);
      });
      console.log("submitQuestions", submitQuestions);
      submitResult.questions = submitQuestions;
      if (!_.isNil(this.id)) {
        submitResult.id = this.id;
      }
      console.log(
        "<=================================submitResult=================================>",
        submitResult
      );
      if (!submitResult.name) {
        this.$message.error(this.$t("survey.needName"));
        return false;
      }
      await this.submitSurvey(submitResult);
    },

    submitSurvey: async function (submitData) {
      let saveUrl = "";
      if (this.id && !this.isCopy) {
        saveUrl = "questionnaire/edit";
      } else {
        saveUrl = "questionnaire/create";
      }
      let res = await window.instance.post(
        openSurveyReqUrl + saveUrl,
        submitData
      );
      res = res.data;
      if (res.code === 200) {
        this.$message.success(res.message);
        this.$router.push({
          path: "/openSurvey/newSurvey",
          query: { published: this.$route.query.published }
        });
      } else {
        this.$message.error(res.message);
      }
    },

    // 跳转tab
    async next(activeName) {
      if (this.activeName == "first") {
        let valid = await this.$refs["form"].validate();
        if (!valid) {
          return;
        }
      }

      console.log(this.form)

      this.activeName = activeName;
    },

    // 添加题目
    addQuestion: function () {
      this.questionsDialog = true;
      this.operation = this.$t("new");
      this.editQuestion = _.cloneDeep(this.initQuestion);
      this.editQuestion.sort = this.questions.length + 1;
      // 题干部分富文本设置
      if (this.editor) {
        // 已经有编辑器,设置内容
        this.currentContent = "";
        this.resetEditor(this.currentContent);
      } else {
        // 没有编辑器,初始化编辑器
        setTimeout(() => {
          this.editorInit();
        }, 100);
      }
    },

    // 编辑题目
    onEditQuestion: function (index) {
      this.questionsDialog = true;
      this.operation = this.$t("edit");
      this.editQuestion = _.cloneDeep(this.questions[index]);
      this.editIndex = index;
      console.log("this.editQuestion", this.editQuestion);
      // 题干部分富文本设置
      if (this.editor) {
        // 已经有编辑器,设置内容
        this.currentContent = this.editQuestion.detail;
        this.resetEditor(this.currentContent);
      } else {
        // 没有编辑器,初始化编辑器
        setTimeout(() => {
          this.currentContent = this.editQuestion.detail;
          this.editorInit(this.currentContent);
        }, 100);
      }
    },

    onSetQuestion: function (index) {
      this.logicDialog = true;
      this.innerQuestionList = [];
      this.innerCheckList = [];
      this.operation = this.$t("edit");
      this.editQuestion = _.cloneDeep(this.questions[index]);
      this.editIndex = index;

      let skipQuestions = _.map(
        _.filter(this.questions, question => question.sort > index + 1),
        (question, i) => ({
          name: question.sort + ". " + question.name,
          id: question.sort
        })
      );
      this.skipOptions = _.concat(this.defaultSkip, skipQuestions);
    },

    addScoreSkip: function () {
      let scoreSkip = this.editQuestion.scoreSkip || [];
      scoreSkip.splice(scoreSkip.length - 1, 0, {
        start: "",
        end: "",
        skipTo: 0,
        enable: false
      });
      this.editQuestion.scoreSkip = scoreSkip;
    },
    addDepScore: function (dep) {
      let currentScoreRanges = dep.scoreRanges;
      let newScoreRange = { start: "", end: "", enable: false, skipTo: 0 };
      currentScoreRanges.splice(
        currentScoreRanges.length - 1,
        0,
        newScoreRange
      );
    },
    onDeleteDep: function (dep) {
      this.editQuestion.dependOn = _.remove(
        this.editQuestion.dependOn,
        i => i.sort != dep.sort
      );
      this.innerCheckList = _.remove(this.innerCheckList, i => i != dep.sort);
    },
    addDepQuestion: function () {
      this.innerQuestionDialog = true;
      let curSort = this.editQuestion.sort;
      const copyQuestions = _.cloneDeep(this.questions);
      // 依赖的题目也可以是题目组里的题目,需要把所有当前题目之前的题目及题目组里的题目提取出来
      const innerQuestionList = [];
      const depQuestions = _.dropRight(
        copyQuestions,
        this.questions.length - curSort + 1
      );
      _.each(depQuestions.filter(q => q.type != 5), question => {
        innerQuestionList.push(question);
      });
      this.innerQuestionList = innerQuestionList;
    },
    confirmSetting: function () {
      this.questions[this.editIndex] = _.cloneDeep(this.editQuestion);
      this.innerQuestionList = [];
      this.innerCheckList = [];

      this.confirmQuestion();
      this.logicDialog = false;
    },
    chooseDepQuestions: function () {
      this.innerQuestionDialog = false;
      _.each(this.innerCheckList, sort => {
        const existedQuestion = _.find(this.editQuestion.dependOn, dep => {
          return dep.sort === sort;
        });
        if (!existedQuestion) {
          const matchedQuestion = _.find(this.innerQuestionList, question => {
            return question.sort === sort;
          });

          if (!this.editQuestion.dependOn) this.editQuestion.dependOn = [];
          if (matchedQuestion.type == 4) {
            this.editQuestion.dependOn.push({
              sort: matchedQuestion.sort,
              type: matchedQuestion.type,
              itemSort: [],
              scoreRanges: []
            });
          }
          if (matchedQuestion.type === 1 || matchedQuestion.type === 2) {
            this.editQuestion.dependOn.push({
              sort: matchedQuestion.sort,
              type: matchedQuestion.type,
              itemSort: [],
              scoreRanges: []
            });
          } else if (matchedQuestion.type === 3) {
            this.editQuestion.dependOn.push({
              sort: matchedQuestion.sort,
              type: matchedQuestion.type,
              itemSort: [],
              scoreRanges: [
                { start: 0, end: "", enable: false, skipTo: 0 },
                {
                  start: "",
                  end: matchedQuestion.maxScore,
                  enable: false,
                  skipTo: 0
                }
              ]
            });
          }
        }
      });
    },
    // 确定题目(编辑/新增)
    confirmQuestion: function () {
      if (
        !this.editQuestion.name
      ) {
        this.$message.error("题目名称不能为空！");
        return;
      }
      if (
        this.editQuestion.type == 5 &&
        this.editQuestion.items.filter(i => i.inUse).length < 1
      ) {
        this.$message.error("请至少启用一道附加题目！");
        return;
      }

      if (this.operation === this.$t("edit")) {
        this.questions[this.editIndex] = _.cloneDeep(this.editQuestion);
        this.questions[this.editIndex].detail = _.cloneDeep(
          this.currentContent
        );
        this.questionsDialog = false;
        this.editQuestion = _.cloneDeep(this.initQuestion);
        console.log("this.questions", this.questions);
      } else {
        const newQuestion = _.cloneDeep(this.editQuestion);
        newQuestion.detail = _.cloneDeep(this.currentContent);
        this.questions.push(newQuestion);
        this.questionsDialog = false;
        this.editQuestion = _.cloneDeep(this.initQuestion);
        console.log("this.questions", this.questions);
      }
    },

    // 添加选项
    addOption: function () {
      if (this.editQuestion.items.length > 9) {
        this.$message.error("最多支持10个选项！");
        return;
      }
      this.editQuestion.items.push({
        content: "",
        isInput: false,
        necessary: false,
        inUse: true,
        sort: this.editQuestion.items.length + 1,
        score: -1
      });
    },

    // 添加其他选项
    addOtherOption: function () {
      if (this.editQuestion.items.length > 9) {
        this.$message.error("最多支持10个选项！");
        return;
      }
      this.editQuestion.items.push({
        content: "",
        isInput: true,
        necessary: false,
        inUse: true,
        sort: this.editQuestion.items.length + 1,
        score: -1
      });
    },

    // 删除问题的选项
    onDeleteItem: function (index) {
      this.editQuestion.items.splice(index, 1);
      this.editQuestion.items.forEach((element, i) => {
        element.sort = i + 1;
      });
    },

    // 删除问题
    onDeleteQuestion: function (index) {
      this.$confirm("确认删除该题目吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.questions.splice(index, 1);
        })
        .catch(_ => { });
    },

    // 切换题目类型
    changeType: function (ev, type) {
      const prevType = type;
      this.$confirm("你确定切换吗？\n" + "切换后题目选项将被清空", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await this.resetQuestion(ev.target.innerText);
        })
        .catch(_ => {
          ev.preventDefault();
          ev.stopPropagation();
          this.editQuestion.type = prevType;
        });
    },

    // 计算指定的type值对应的题目类型
    computeType: function (type) {
      let result;
      switch (type) {
        case 1:
          result = "单选题";
          break;
        case 2:
          result = "多选题";
          break;
        case 3:
          result = "NPS量表题";
          break;
        case 4:
          result = "填空题";
          break;
        case 5:
          result = "门店信息题";
          break;
        default:
          result = "";
      }
      return result;
    },

    computeScore: function (type, score) {
      if (type != 1) return "";
      let result;
      switch (score) {
        case 0:
          result = "0分项";
          break;
        case 1:
          result = "1分项";
          break;
        default:
          result = "不计分项";
      }
      return result;
    },

    // 重置问题的选项/分值
    resetQuestion: async function (target) {
      this.editQuestion.maxScore = 10;
      // this.editQuestion.maxText = ''
      // this.editQuestion.minText = ''
      let that = this;
      if (target && target === "门店信息题") {
        // this.$nextTick(()=>{
        that.editQuestion.items = [
          {
            content: "门店（必填）",
            inUse: true,
            isInput: true,
            necessary: true,
            tag: "door",
            sort: 1,
            score: -1,
          },
          // {
          //   content: "邮箱（必填）",
          //   inUse: true,
          //   isInput: true,
          //   necessary: true,
          //   tag: "email",
          //   sort: 2,
          //   score: -1,
          // },
          {
            content: "姓名",
            inUse: false,
            isInput: true,
            necessary: false,
            tag: "name",
            sort: 2,
            score: -1,
          },
          {
            content: "手机号",
            inUse: false,
            isInput: true,
            necessary: false,
            tag: "cellphone",
            sort: 3,
            score: -1,
          }
        ];
        // })
      } else {
        this.editQuestion.items = [];
      }
    },

    // 改变题目顺序
    changeSort(value, index) {
      let _this = this;
      this.$messagebox
        .confirm("变更顺序后需重新设置题目依赖，是否继续?", "提示", {
          confirmButtonText: "确认",
          cancleButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          // value是输入的题目顺序
          // index是输入之前题目原来的顺序
          // 复制一份问题列表
          const copyQuestions = _.cloneDeep(_this.questions);
          // 移除需要改顺序的那一题
          const removedQuestion = _.pullAt(copyQuestions, index)[0];
          // 在原来的questions的value位置,插入这道题
          copyQuestions.splice(value - 1, 0, removedQuestion);
          _.each(copyQuestions, (ques, j) => {
            ques.sort = j + 1;
          });
          _.each(copyQuestions, question => {
            question.scoreSkip = [];
            question.dependOn = [];
            _.each(question.items, item => {
              item.skipTo = 0;
            });
          });
          _this.questions = _.cloneDeep(copyQuestions);
        })
        .catch(() => {
          this.$message.info("操作取消！");
          this.questions[index].sort = index + 1;
          return false;
        });
    },

    // 获取选中的角色
    getSelectedLabels(data) {
      const selectedIds = data;
      const result = [];
      _.each(this.tagOptionsAll, option => {
        if (_.indexOf(selectedIds, option.roleCode) !== -1) {
          result.push(option.roleName);
        }
      });
      console.log(result)
      this.accessRoles = result;
    },
    // 获取选中的角色
    getSelectedLabels2(data) {
      const selectedIds = data;
      const result = [];
      _.each(this.tagOptionsAll, option => {
        if (_.indexOf(selectedIds, option.roleCode) !== -1) {
          result.push(option.roleName);
        }
      });
      console.log(result)
      this.taskRoles = result;
    },
    // 获取角色id
    getIdsFromOptions(options, checked) {
      const result = [];
      const copyOptions = _.cloneDeep(options);
      _.each(copyOptions, opt => {
        if (_.indexOf(checked, opt.roleName) !== -1) {
          result.push(opt.roleCode);
        }
      });
      return result;
    },

    // 获取角色列表
    getPureOptionList(optionsAll, name) {
      const keyName = name || "name";
      const options = [];
      _.each(optionsAll, tag => options.push(tag[keyName]));
      return options;
    },
    upload() {
      this.$refs.uploadBtn.$el.click();
    },
    beforeUpload(file) {
      let that = this;
      const isSupport =
        file.name.toLowerCase().endsWith(".xls") ||
        file.name.toLowerCase().endsWith(".xlsx");

      if (!isSupport) {
        this.$message.error("仅支持excel文件");
        return false;
      }

      let formData = new FormData();
      formData.append("file", file);
      window.instance
        .post(openSurveyReqUrl + "doors/import", formData)
        .then(res => {
          let { data } = res.data;
          that.form.posIdStr = data.join(",");
          that.form.posIds = data;
          // console.log(file.name);
          if (res.data.code === 200) {
            this.$message.success("导入成功！");
          } else {
            this.$message.error(res.data.message);
          }
        });

      return false;
    },
    downloadTemplate: async function () {
      let response = await window.instance({
        method: "get",
        responseType: "blob",
        url: openSurveyReqUrl + "doors/template"
      });

      let fileName = decodeURI(
        response.headers["content-disposition"].split("''")[1]
      );
      let res = response.data;
      const blob = new Blob([res], { type: "application/vnd.ms-excel" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(a.href);
      a.remove();
    }
  }
};
</script>

<style>
.w-e-text-container {
  height: 200px !important;
}

textarea {
  font-family: "Arial";
}

.inner-disabled>.el-input__inner {
  background-color: #f5f7fa !important;
  cursor: pointer;
}

#editNewSurvey .card-box {
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px;
  padding: 10px;
  border-radius: 5px;
}
</style>
<style scoped lang="sass">
#editNewSurvey
.checkboxList
  .el-checkbox
    display: block
    margin: 14px 0
    font-weight: 300
  em
    font-style: normal
.customFormItem
  display: flex
  margin-bottom: 20px

.customFormItem .label
  text-align: right
  width: 200px
  vertical-align: middle
  float: left
  font-size: 14px
  color: #606266
  line-height: 36px
  padding: 0 12px 0 0
  -webkit-box-sizing: border-box
  box-sizing: border-box
  flex-shrink: 0

.customFormItemInner .label
  width: 100px

.customFormItem .label em
  font-style: normal
  color: #d82341
  margin-right: 4px

.customFormItem .input-box
  font-size: 12px
  color: #606266

.customFormItem .input-box span
  margin-left: 5px

.customFormItem  .formItemContent
  line-height: 36px
  width: 100%

.scoreText
  ul
    list-style: none
    margin: 0 100px
    padding: 0
    display: flex
    justify-content: space-between
    li
      display: block
      width: 20px
      height: 20px
      border-radius: 100%
      background: #ddd
      overflow: hidden
  .scoreTextInput
    padding: 20px 34px 0

.questionsContainer
  .innerQuestionBox
    margin: 20px 0
  .questionBox
    list-style: none
    margin: 0
    padding: 0
    &:nth-last-of-type()
      border-bottom: 0
    li
      list-style: none
      font-size: 14px
      color: #606266
      line-height: 40px
      border-bottom: 1px solid #efefef
      margin-bottom: 20px
      padding-bottom: 20px
      &:last-child
        border-bottom: 0
        margin-bottom: 0
        padding-bottom: 0
      i
        cursor: pointer
        font-size: 16px

      .options
        display: flex
        flex-direction: column
        font-size: 12px
        color: #aaa
        .option
          line-height: 24px



.questionOptionsContainer
  .optionsBox
    list-style: none
    margin: 0
    padding: 0
    &:nth-last-of-type()
      border-bottom: 0
    li
      line-height: 40px
      border-bottom: 1px solid #efefef
      margin-bottom: 20px
      padding: 0
      padding-bottom: 18px
      &:last-child
        border-bottom: 0
        margin-bottom: 0
      i
        cursor: pointer

footer
  padding-top: 20px
  text-align: center


.optionBox
  border: 1px solid rgb(220, 223, 230)
  height: 38px
  line-height: 38px
  margin-right: 30px
  border-radius: 5px
  text-indent: 10px

.scopeBox
  margin-right: 30px
  margin-left: 16px

.scopeInput
  width: 50px

.buttonContainer
  margin: 8px 0 0 16px

.depContainer
  border-top: 1px solid #eee
  margin-top: 40px
  padding-top: 20px

.align-item
  line-height: 36px

.depList
  li
    margin-bottom: 24px
    i
      color: #67c23a
      cursor: pointer
      font-size: 16px

.checkboxList
  .el-checkbox
    display: block
    margin: 14px 0
    font-weight: 300
  em
    font-style: normal
</style>



// WEBPACK FOOTER //
// src/openSurvey/pages/EditNewSurvey.vue